import { useUserStoreWithOut } from '/@/store/modules/user';
import { showLogin, LoginType } from '@flinks/login';
import '@flinks/login/lib/style.css';
import { linksEvent, LinksEventType } from '/@/libs/eventBus';
import { isFunction } from '@flinks/utils';
import { handleInviteLinks } from '/@/api/user';

export function useLogin() {
  async function handler(res) {
    const userStore = useUserStoreWithOut();
    userStore.clearState();
    userStore.setToken(res.token);
    const inviteLinkInfo = userStore.getInviteLinkInfo;
    if (inviteLinkInfo?.id) {
      handleInviteLinks({ inviteLinkId: inviteLinkInfo.id });
    }
    await userStore.getUserInfoAction();
    linksEvent.emit(LinksEventType.reloadPage);
  }

  function login() {
    const userStore = useUserStoreWithOut();
    userStore.clearState();
    showLogin({
      companyId: userStore.getCompanyId,
      showWxLogin: !!userStore.getWebConfigs?.openWxAuth,
      showDefaultLoginMethod: LoginType.sms,
      onSuccess: handler,
      showClose: false,
      webChatLoginType: 'webH5Login',
    });
  }

  function runAfterLogin(fn: () => void) {
    const userStore = useUserStoreWithOut();
    if (!userStore.getUserInfo.id) {
      login();
    } else {
      isFunction(fn) && fn();
    }
  }

  return {
    login,
    runAfterLogin,
  };
}
